import {
  EcomCashoutBootstrapParams,
  EcomCashoutSetecomPageModel,
} from './model';
import { CashoutOperation } from '../model';

const CASHOUT_CURRENCY_CODE = 'MDL';

export function mapBootstrapParams(
  input: unknown
): EcomCashoutBootstrapParams {
  const dto = isRecord(input) ? input : {};

  return {
    paymentId: readNumber(dto, 'PaymentId'),
    signature: readString(dto, 'Signature'),
  };
}

export function mapSetecomPageModel(
  input: unknown,
  operation: CashoutOperation | null = null,
): EcomCashoutSetecomPageModel {
  const params = mapBootstrapParams(input);
  const total = resolveAmount(operation) / 100;
  const currencyCode = CASHOUT_CURRENCY_CODE;

  return {
    amountLabel: formatMoney(total, currencyCode),
    operationId: resolveOperationId(params.paymentId, operation),
    operationStatus: operation?.cashoutStatus ?? '',
    totalLabel: formatMoney(total, currencyCode),
    transferNumber: resolveTransferNumber(params.paymentId, operation),
    merchantName: operation?.merchantName ?? '',
    customerEmail: operation?.email ?? '',
    expirationDateLabel: formatDateTime(operation?.expirationDate),
    logoCode: operation?.logoCode ?? '',
    successUrl: operation?.successUrl ?? '',
  };
}

function isRecord(input: unknown): input is Record<string, unknown> {
  return typeof input === 'object' && input !== null;
}

function readNumber(
  record: Record<string, unknown> | null,
  key: string,
): number {
  return toNumber(record?.[key]);
}

function readString(record: Record<string, unknown>, key: string): string {
  const value = record[key];
  return typeof value === 'string' ? value.trim() : '';
}

function toNumber(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

function resolveAmount(operation: CashoutOperation | null): number {
  return operation?.amountMdl ?? 0;
}

function resolveTransferNumber(
  operationId: number,
  operation: CashoutOperation | null,
): string {
  return operation?.cashoutCode || (operationId > 0 ? operationId.toString() : '');
}

function resolveOperationId(
  operationId: number,
  operation: CashoutOperation | null,
): string {
  return operation?.id?.toString() ?? (operationId > 0 ? operationId.toString() : '');
}

function formatMoney(amount: number, currencyCode: string): string {
  return `${amount.toFixed(2)} ${currencyCode}`;
}

function formatDateTime(value: string | undefined): string {
  if (!value) {
    return '';
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}
